/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import { Turbo } from "@hotwired/turbo-rails";
import "../controllers";
import "../ui/bootstrap_ui";
import "../ui/confirm";
import { ApiClient, ApiProvider } from "jsonapi-react";
import Constants from "util/Constants";
import schema from "util/Schema";
import ReactOnRails from "react-on-rails/client";
import React from "react";
import * as Sentry from "@sentry/react";

window.Turbo = Turbo;

Sentry.init({
  dsn: "https://f9e96ab7ab7242e3b0a8e2dbc9d92ab0@o962374.ingest.sentry.io/5910764",
  integrations: [Sentry.browserTracingIntegration()],
  // Turbo aborts in-flight frame fetches when a frame is re-requested or the page is left.
  ignoreErrors: [/AbortError/],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  // NOTE(vladimir.trebicky@gmail.com): This seems to be a paid feature.
  tracesSampleRate: 0.0,
});

// A frame whose answer lacks it shows a notice instead of Turbo's silent
// "Content missing". For the server that is a 200 answer, so only the browser
// can report it.
document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault();
  event.target.innerHTML =
    '<h5>Olin má problém</h5><p><i class="fa fa-exclamation-triangle"></i> Něco je špatně, někdo už dostal e-mail a snad to co nejdříve vyřeší.</p>';
  const response = event.detail.response;
  Sentry.captureMessage(
    `Turbo frame missing: ${event.target.id} <- ${response.status} ${response.url}`,
    "error"
  );
});

// Mount and unmount the components on Turbo's render events (Turbo Drive
// swaps bodies without a page load).
ReactOnRails.setOptions({ turbo: true });

ReactOnRails.registerStore({
  api: () =>
    new ApiClient({
      url: "/api",
      schema: schema,
      headers: {
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    }),
  constants: (props) => props,
});

const WithProviders = (Component) => {
  return (props) => (
    <Constants.Provider value={ReactOnRails.getStore("constants")}>
      <ApiProvider client={ReactOnRails.getStore("api")}>
        <Component {...props} />
      </ApiProvider>
    </Constants.Provider>
  );
};
